import React from "react";

import { Button, useBreakpoint } from "ii-ui-kit";

import keyImg from "images/key.png";
import "./index.scss";

/** Ошибка "Превышено количество попыток "*/
export const DocTooManyAttempts = () => {
  const isMobile = useBreakpoint((builder) => builder.under("md"));

  const goToMain = () => {
    if (window.loginRestartFlowUrl) {
      window.location.replace(window.loginRestartFlowUrl);
    }
  };

  const handleCallButtonClick = () => {
    location.replace("tel:74957204898");
  };

  const renderTextForMobile = () => (
    <div className="doc-attempts__text">
      <div className={"doc-attempts__paragraph"}>
        В целях безопасности восстановление пароля заблокировано.
      </div>
      <div className={"doc-attempts__paragraph"}>
        Обратитесь в службу поддержки по телефону{" "}
        <a href="tel:74957204898">+7 495 720-48-98</a>
      </div>
    </div>
  );

  const renderTextForDesktop = () => (
    <div className="doc-attempts__text">
      В целях безопасности восстановление пароля заблокировано. Обратитесь в
      службу поддержки по телефону{" "}
      <a href="tel:74957204898">+7 495 720-48-98</a>
    </div>
  );

  const renderText = () =>
    isMobile ? renderTextForMobile() : renderTextForDesktop();

  return (
    <div className={"doc-attempts"}>
      <img className="doc-attempts__img" src={keyImg} />
      <div className="doc-attempts__title">Превышено число попыток</div>
      {renderText()}
      <Button
        className={"doc-attempts__button"}
        size={"l"}
        title={"Вернуться на главную"}
        onClick={goToMain}
      />
      <Button
        className={"doc-attempts__button"}
        color={"secondary"}
        size={"l"}
        title={"Позвонить в поддержку"}
        onClick={handleCallButtonClick}
      />
    </div>
  );
};
